import axios from "axios";

// Base URL depuis le .env
const API_URL = `${process.env.REACT_APP_API_URL}/rendez-vous`;


export const getRendezVous = () =>
  axios.get(API_URL);



export const dashboardTechniciens = (mois) =>
  axios.get(`${API_URL}/dashboard`, {
    params: {
      mois
    }
  });



export const getDashboardParMois = () =>
  axios.get(`${API_URL}/dashboard/mois`);



export const getDerniersRendezVous = () =>
  axios.get(`${API_URL}/dashboard/derniers-rendez-vous`);



export const getRendezVousById = (id) =>
  axios.get(`${API_URL}/${id}`);



export const createRendezVous = (data) =>
  axios.post(API_URL, data);



export const deleteRendezVous = (id) =>
  axios.delete(`${API_URL}/${id}`);



export const updateEtatRendezVous = (id, data) =>
  axios.put(`${API_URL}/${id}/etat`, data);



export const updateHeursRendezVous = (id, data) =>
  axios.put(`${API_URL}/${id}/heure-fin`, data);



export const updateRemarque = async (id, data) =>
  axios.put(`${API_URL}/${id}/remarque`, data);



export const updateRendezVous = async (id, data) => {

  try {

    const res = await axios.put(
      `${API_URL}/${id}`,
      data
    );

    console.log(
      "Rendez-vous mis à jour :",
      res.data
    );

    return res.data;


  } catch (ex) {

    console.error(
      "Erreur lors de la mise à jour :",
      ex.response
      ? ex.response.data
      : ex
    );

  }

};